<template>
	<div class="page">
		<div class="pageTitleBox" style="align-items: center;">
			<div class="boxNameL">
				医疗服务
			</div>
			<el-button type="warning" @click="isBack" size="small">返回</el-button>
			<!-- <div class="boxNameR">
				<el-button type="warning" @click="isBack" size="small">返回</el-button>
			</div> -->
		</div>
		<div class="content">
			<div class="title">套餐属性</div>
			<el-form ref="form" :model="editParams" label-width="90px">
				<el-form-item label="类型" class="">
					<el-cascader size="mini" filterable ref="cascader" clearable v-model="productTypeIds" :options="categoryData[0].children"
					:show-all-levels="true" :props="{ label: 'label',value:'id' }" @change="changeCategory"></el-cascader>
				</el-form-item>
				<el-form-item label="项目名称">
					<el-input style="width: 150px;" size="mini" v-model="editParams.title" placeholder="请输入内容"></el-input>
				</el-form-item>
				<el-form-item label="适用品种">
					<el-radio-group v-model="editParams.applytype">
						<el-radio label="0">通用</el-radio>
						<el-radio label="1">猫用</el-radio>
						<el-radio label="2">犬用</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="参与提成">
					<el-radio-group v-model="editParams.join_commission">
						<el-radio :label="Number(1)">参与</el-radio>
						<el-radio :label="Number(0)">不参与</el-radio>
					</el-radio-group>
				</el-form-item>
				<storeSelect v-if='showShops' title='应用门店' :storeIds='storeIds' @sendStore='getStores'></storeSelect>
				<div class="title">设置服务项</div>
				<el-form-item label="自定义价格">
					<el-radio-group v-model="editParams.allow_custom_discount">
						<el-radio :label="Number(1)">是</el-radio>
						<el-radio :label="Number(0)">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="设置体重">
					<el-popover placement="top" width="280" v-model="addweight">
						<div style="text-align: center; margin: 5px 0 10px 0">添加体重</div>
						<el-input size="mini" style="width: 130px;" placeholder="请输入" v-model="weight.minweight">
							<template slot="append">kg</template>
						</el-input>--
						<el-input size="mini" style="width: 130px;" placeholder="请输入" v-model="weight.maxweight">
							<template slot="append">kg</template>
						</el-input>
						<div style="text-align: center; margin-top: 10px">
							<el-button type="primary" size="mini" @click='sureweight'>确定</el-button>
						</div>
						<el-button size="mini" slot="reference" @click='addWeight'>新建</el-button>
					</el-popover>
					<div >
						<div class="weighttabs" v-for="(item,index) in editParams.service_info" :key='index' @click="changetabs(index)">
							<div :class="['weighttab',{active:active==index}]">
								<span>{{item.weight_detail.min_weight}}kg</span>--<span>{{item.weight_detail.max_weight}}kg</span>
							</div>
							<div class="weightbtn">
								<el-popover placement="bottom" width="280" @hide="hidePopver(item)">
									<div style="text-align: center; margin: 5px 0 10px 0">编辑体重</div>
									<el-input size="mini" style="width: 130px;" placeholder="请输入" v-model="weight.minweight">
										<template slot="append">kg</template>
									</el-input>--
									<el-input size="mini" style="width: 130px;" placeholder="请输入" v-model="weight.maxweight">
										<template slot="append">kg</template>
									</el-input>

									<el-button size="mini" slot="reference" type="text" @click='editWeight(item,index)'>编辑</el-button>
								</el-popover>
								<!-- <span>编辑</span> -->
								<span style="margin-left: 10px;" @click="deletWeight(index)">删除</span>
							</div>
						</div>
						
					</div>
					
					<div v-if="editParams.service_info[active]">
						<div>
							<el-form-item label="类型" label-width="50px" style="margin-left: -50px;">
								<el-checkbox-group v-model="checkList">
									<el-checkbox label="0" @change='checked=>changeType(checked,0,editParams.service_info[active].service_items)'>天</el-checkbox>
									<el-checkbox label="1" @change='checked=>changeType(checked,1,editParams.service_info[active].service_items)'>小时</el-checkbox>
									<el-checkbox label="2" @change='checked=>changeType(checked,2,editParams.service_info[active].service_items)'>半小时</el-checkbox>
									<el-checkbox label="3" @change='checked=>changeType(checked,3,editParams.service_info[active].service_items)'>次</el-checkbox>
								</el-checkbox-group>
							</el-form-item>
							<div v-for="(weightType,num) in editParams.service_info[active].service_items" :key='num'>
								<el-form-item  :label="'医疗属性('+weightType.frequency_text+')'" label-width="120px" style="margin-left: -120px;">
									<div v-for="(weightobj,key) in weightType.service_object" :key='key'>
										<el-input  size="mini" style="width: 120px;" v-model="weightobj.extend_attr" placeholder="请输入"></el-input>
										<el-input size="mini" style="width: 120px; margin:0 5px;" v-model="weightobj.service_objectName" placeholder="请输入医疗属性"></el-input>
										<span v-if="editParams.allow_custom_discount==0">普通价</span><el-input v-if="editParams.allow_custom_discount==0" size="mini" style="width: 120px;" v-model="weightobj.price" placeholder="请输入服务价格"></el-input>
										<span v-if="editParams.allow_custom_discount==0">会员价</span><el-input v-if="editParams.allow_custom_discount==0" type="number" :max="weightobj.price" size="mini" style="width: 120px;" v-model.number="weightobj.mprice" placeholder="请输入会员价格"></el-input>
										<span v-if="editParams.allow_custom_discount==1">
											价格区间
											<el-input   size="mini" style="width: 120px;" v-model="weightobj.min_price " placeholder="请输入最小价格"></el-input>
											-
											<el-input  size="mini" style="width: 120px;" v-model="weightobj.max_price" placeholder="请输入最大价格"></el-input>
											<!-- 最低折扣
											<el-input size="mini" style="width: 80px;" v-model="weightobj.min_discount" placeholder="请输入"></el-input>折
											<span> 最低价格：¥ {{weightobj.price*weightobj.min_discount}}</span> -->
										</span>
					
										<el-button style="margin-left: 5px;" v-if="key==0" type="text" @click='addweightobj(weightType.service_object)'>新建</el-button>
										<el-button style="margin-left: 5px;" v-if="weightType.service_object.length>1&&key!=0" type="text" @click='deletWeightobj(weightType.service_object,key)'>删除</el-button>
									</div>
								</el-form-item>
							</div>
						</div>
						<!-- <div class="goodsrelate">
							<el-button size="mini" type="primary">添加耗材</el-button>
						</div> -->
					</div>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" @click="onSubmit('form')">提交</el-button>
					
				</el-form-item>
			</el-form>
		</div>

		<!-- <dialogNewGoods :dialogStatus='isAddNewGoods' @closeDialog='closeDialog' :isShopPurchase='true'></dialogNewGoods> -->

	</div>
</template>

<script>
	import storeSelect from "../../../components/storeSelect.vue"
	// import dialogNewGoods from '../../../components/dialog_newgood.vue'
	import {
		getProductTypeList,
		getProductTypeDl,
		getServiceDictList,
		setMedicalServiceList,
		getMedicalServiceDl
	} from '../../../api/productApi.js'
	export default {
		components: {
			storeSelect,
			// dialogNewGoods
		},
		data() {
			return {
				showShops: true,
				active: 0,
				categoryData: [],
				productTypeIds: [],
				addweight: false,
				editParams: {
					serviceId: '',
					title: '',
					category_info: {
						_id: '',
						name: '',
					},
					category_list: [],
					applytype: '0',
					allow_custom_discount: 0,
					service_info: [],
					join_commission: 1,
					shop_info: [],
				},
				storeIds: [],
				weight: {
					minweight: '',
					maxweight: '',
				},
				checkList: ['3'],
				pinzhong: [],
				tezheng: [],
			}
		},
		methods: {
			isBack() {
				this.$alert('你正在编辑生活服务,返回数据将不会保存,确认返回', '确认返回', {
					confirmButtonText: '确定',
					callback: action => {
						if (action == 'confirm') {
							this.$router.back();
						} else {
							this.$message({
								type: 'info',
								message: '取消返回'
							});
						}
					}
				});
			},
			getProductTypeList() {
				getProductTypeList({
					category: '医疗服务'
				}).then(res => {
					if (res.code == 0) {
						console.log(res,'医疗服务');
						this.categoryData = res.data;
					}
				})
			},
			changeCategory(val) {
				if (val.length > 0) {
					getProductTypeDl({
						id: val[val.length - 1]
					}).then(res => {
						if (res.code == 0) {
							this.editParams.category_info._id = res.data._id;
							this.editParams.category_info.name = res.data.name;
							this.editParams.category_info.code = res.data.code;
							this.editParams.category_list = res.data.parent_all;
						}
					})
				}
			},
			sureweight() {
				if (!this.weight.minweight || !this.weight.maxweight) {
					this.$message({
						type: 'info',
						message: '请填写体重再进行确认操作'
					});
				} else {
					this.editParams.service_info.push({
						_id: '',
						weight_detail: {
							min_weight: this.weight.minweight,
							max_weight: this.weight.maxweight
						},
						service_items: [{
							frequency_code: '3',
							frequency_text: '次',
							service_object: [{
								service_objectId: '',
								service_objectName: '',
								extend_attr:'',
								price: 0,
								mprice:0,
								min_price :0,
								max_price :0,
								min_discount: 0,
							}],
						}],
						use_goods: {
							must_use: 0,
							select_way: '0',
							select_num: 0,
							goods_list: [],
						}
					});
					this.weight.minweight = '';
					this.weight.maxweight = '';
					this.addweight = false;

				}
			},
			deletWeight(index) {
				this.$confirm('你确定删除该体重及配置项, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.editParams.service_info.splice(index, 1)
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			editWeight(item) {
				this.weight.minweight = item.weight_detail.min_weight;
				this.weight.maxweight = item.weight_detail.max_weight;
			},
			hidePopver(item) {
				item.weight_detail.min_weight = this.weight.minweight;
				item.weight_detail.max_weight = this.weight.maxweight;
			},
			addWeight() {
				this.weight.minweight = '';
				this.weight.maxweight = '';
			},
			addweightobj(arr) {
				arr.push({
					service_objectId: '',
					service_objectName: '',
					price: 0,
					mprice:0,
					extend_attr:'',
					min_price :0,
					max_price :0,
					min_discount: 0,
				})
			},
			deletWeightobj(arr, index) {
				arr.splice(index, 1)
			},
			changeType(checked, type, arr) {
				var codes;
				var text;
				if (type == 1) {
					codes = '1'
					text = '小时'
				} else if (type == 2) {
					codes = '2'
					text = '半小时'
				} else if (type == 3) {
					codes = '3'
					text = '次'
				} else if (type == 0) {
					codes = '0'
					text = '天'
				}

				console.log(checked, 'checked')
				if (checked) {
					arr.push({
						frequency_code: codes,
						frequency_text: text,
						service_object: [{
							service_objectId: '',
							service_objectName: '',
							apply_varieties: {
								_id: '',
								name: '',
								code: '',
							},
							apply_features: {
								_id: '',
								name: '',
								code: '',
							},
							price: 0,
							mprice:0,
							extend_attr:'',
							min_price :0,
							max_price :0,
							min_discount: 0,
						}],
						use_goods: {
							must_use: 0,
							select_way: '0',
							select_num: 0,
							goods_list: [],
						},
					})
				} else {
					let index = arr.findIndex(item => {
						return item.frequency_code == type
					})
					arr.splice(index, 1)
				}

			},
			getServiceDictList(type) {
				getServiceDictList({
					type
				}).then(res => {
					if (res.code == 0) {
						if (type == '品种') {
							this.pinzhong = res.data.data;
						} else {
							this.tezheng = res.data.data;
						}
					}
				})
			},
			onSubmit(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						setMedicalServiceList(
							this.editParams
						).then(res => {
							if (res.code == 0) {
								this.$message({
									message: '设置成功',
									type: 'success'
								});
								this.$router.push({
									path: '/medicalservice/medicalservice'
								})
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			getMedicalServiceDl(id) {
				this.showShops = false;
				this.storeIds = [];
				getMedicalServiceDl({
					id,
				}).then(res => {
					if (res.code == 0) {
						this.editParams = res.data;
						res.data.category_list.forEach((item, index) => {
							if (index > 0) {
								this.productTypeIds.push(item._id)
							}
						})
						this.productTypeIds.push(res.data.category_info._id);
						this.checkList = this.editParams.service_info[this.active].service_items.map(item=>{
							return item.frequency_code;
						})
					
						this.storeIds = this.editParams.shop_info.map(item => {
							return item.shop_id
						})
						this.showShops = true;
					
						console.log(this.productTypeIds)

					}
				})
			},
			getStores(data) {
				this.editParams.shop_info = data;
			},
			changetabs(index){
				this.active = index;
				this.checkList = [];
				this.checkList = this.editParams.service_info[index].service_items.map(item=>{
					return item.frequency_code;
				})
			}



		},
		created() {
			this.getProductTypeList();
			this.getServiceDictList('品种');
			this.getServiceDictList('特征');
			if (this.$route.query.id) {
				this.getMedicalServiceDl(this.$route.query.id)
			} else {
				this.storeIds = this.$store.state.userInfo.shops.map(item => {
					return item.shop_id
				})
				this.editParams.shop_info = this.$store.state.userInfo.shops
			}


		}
	}
</script>

<style lang="scss" scoped="scoped">
	.content {
		padding: 0 24px;
		background-color: #fff;

		.title {
			color: #2A2A2A;
			border-bottom: 1px solid #E2E2E2;
			padding: 15px 0px;
			box-sizing: content-box;
			position: relative;
		}

		.title::before {
			position: absolute;
			content: '';
			color: #1890FF;
			background-color: #F5882A;
			height: 16px;
			width: 2px;
			left: -10px;
			right: 0;
			z-index: 10;
		}

		.weighttabs {
			display: inline-block;
			border: 1px solid rgba(0, 0, 0, 0.15);
			border-radius: 5px;
			margin-right: 10px;
			vertical-align: top;

			.weighttab {
				padding: 0 10px;
			}

			.active {
				background-color: #F5882A;
				color: #fff;
			}

			.weightbtn {
				padding: 0 10px;
				border-top: 1px solid rgba(0, 0, 0, 0.15);
				font-size: 12px;
			}
		}
	}
</style>
